<template>
	<button class="is-flex link-row"  @click="!edit ? Open(link) : null;">
		<div class="is-flex is-align-items-center">
			<div style="white-space: nowrap">
				<div class="link-icon mr-5">
					<o-icon icon="link"></o-icon>
				</div>
			</div>
			<div>
				<h4>
					{{ link.title }}
				</h4>
				<div>{{ link.description }}</div>
			</div>
		</div>
		<div class="buttons">
			<o-button v-if="!edit" @click="Open(link)" variant="primary" class="is-light link-button">
				{{ link.text || "Open" }}
			</o-button>

			<o-button size="small" variant="primary" icon-right="pencil" @click="Edit" v-if="edit">
				Edit
			</o-button>
			<o-button size="small" variant="danger" icon-right="trash" @click="Remove" v-if="edit">
				Remove
			</o-button>
		</div>
	</button>
</template>
<script>
	import { ref } from "vue";
	import { useRouter } from "vue-router";

	export default {
		props: {
			link: {
				type: Object,
				default: null
			},

			edit: {
				type: Boolean,
				default: false
			}
		},
		emits: ["remove", "edit"],
		setup(props, context) {
			const $router = useRouter();

			const Remove = () => {
				context.emit("remove");
			};

			const Edit = () => {
				context.emit("edit", props.link.value);
			};

			const Open = (link) => {
				if (link.href.startsWith("http") || link.href.startsWith("mailto")) {
					window.open(link.href, link.target);
					//window.location.assign(props.href);
				} else {
					if (link.href.startsWith("/")) {
						$router.push({ path: link.href });
					} else {
						$router.push({ name: link.href });
					}
				}
			};

			return {
				Edit,
				Remove,
				Open
			};
		}
	};
</script>

<style lang="scss" scoped>
	@import "@/assets/css/globalVars.scss";

	.link-row {
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin: 0;
		border: none;
		border-radius: $radius-small;
		width: 100%;
		padding: 0;
		background-color: transparent;
		text-align: left;

		&:not(:last-child) {
			margin-bottom: $margin-element-medium;
		}

		&:hover {
			cursor: pointer;
			background-color: $boyden-blue-lighter;

			& .link-button {
				background-color: lighten($boyden-blue-lighter, 3%);
			}
			& .link-icon {
				background-color: lighten($boyden-blue-lighter, 3%);
			}
		}
	}

	.link-icon {
		display: flex;
		margin-top: $margin-element-tiny;
		margin-bottom: $margin-element-tiny;
		margin-left: $margin-element-tiny;
		border-radius: $radius-medium;
		justify-content: center;
		align-items: center;
		background: $boyden-blue-lighter;

		white-space: nowrap;
		color: $boyden-blue;
		font-size: pxUnits(32);
		height: pxUnits(60);
		width: pxUnits(60);
	}
	.buttons {
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
	}
</style>
